define("shared/modifiers/wheel-pan", ["exports", "ember-modifier"], function (_exports, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier"eaimeta@70e063a35619d71f
  /** Approximate pixels-per-line for DOM_DELTA_LINE wheel events (matches typical browser line height). */
  const LINE_HEIGHT_PX = 16;

  /**
   * Converts a wheel delta to pixels regardless of the event's deltaMode. Mouse wheels in some
   * browsers (notably Firefox) report deltas in lines or pages rather than pixels; treating those
   * raw values as pixels makes panning feel like it "barely moves".
   */
  function deltaToPixels(delta, deltaMode, pageSize) {
    if (deltaMode === WheelEvent.DOM_DELTA_LINE) {
      return delta * LINE_HEIGHT_PX;
    }
    if (deltaMode === WheelEvent.DOM_DELTA_PAGE) {
      return delta * pageSize;
    }
    return delta;
  }

  /**
   * Translates a mouse-wheel gesture into panning of a scrollable element.
   *
   * Each wheel gesture pans along its own axis when that axis can scroll: a vertical wheel (deltaY)
   * pans vertically and a horizontal/tilt wheel (deltaX) pans horizontally. A horizontal wheel never
   * pans vertically. The one exception is the wide-image case: a vertical wheel falls back to
   * horizontal panning when the content overflows only horizontally (so "Scroll to pan" works for wide
   * previews). Whenever the modifier pans, it performs the scroll itself and consumes the event
   * (preventDefault + stopPropagation). This is deliberate: the modal backdrop is itself scrollable,
   * so leaving scrolling to the browser let it pick the scroll target unreliably, making the preview
   * pan only intermittently. Owning the scroll keeps panning deterministic and stops the gesture from
   * chaining to the backdrop.
   */
  function wheelPan(element) {
    const onWheel = event => {
      if (event.ctrlKey) {
        // ctrl/cmd+wheel is browser zoom — never hijack it.
        return;
      }
      const canScrollY = element.scrollHeight > element.clientHeight;
      const canScrollX = element.scrollWidth > element.clientWidth;
      if (!canScrollY && !canScrollX) {
        return;
      }
      const isHorizontalGesture = Math.abs(event.deltaX) > Math.abs(event.deltaY);
      if (isHorizontalGesture) {
        // Horizontal/tilt wheel: pan horizontally only. Never re-route to the vertical axis.
        if (!canScrollX) {
          return;
        }
        element.scrollLeft += deltaToPixels(event.deltaX, event.deltaMode, element.clientWidth);
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      // Vertical wheel: pan vertically when there is a vertical axis to scroll...
      if (canScrollY) {
        element.scrollTop += deltaToPixels(event.deltaY, event.deltaMode, element.clientHeight);
        event.preventDefault();
        event.stopPropagation();
        return;
      }

      // ...otherwise fall back to horizontal panning for wide-only previews.
      element.scrollLeft += deltaToPixels(event.deltaY, event.deltaMode, element.clientWidth);
      event.preventDefault();
      event.stopPropagation();
    };

    // `wheel` element listeners are active by default, so preventDefault works; be explicit.
    element.addEventListener('wheel', onWheel, {
      passive: false
    });
    return () => element.removeEventListener('wheel', onWheel);
  }
  const wheelPanModifier = (0, _emberModifier.modifier)(wheelPan, {
    eager: false
  });
  var _default = _exports.default = wheelPanModifier;
});